import React, { useState, useContext } from "react";

import "./deleteAccount.scss";
import DeleteAccountSecurity from "components/DeleteAccountSecurity/index";
import { useToast } from "components/Toaster/index";
import { ManageUser as MU } from "@induz/sdk";
import { useNavigate } from "react-router-dom";
import { signInContext } from "context/SigninContext";

function DeleteAccount({ hideDescription, isMobile }) {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const deleteHadler = () => {
    setShowDeleteModal(true);
  };
  const { userMail } = useContext(signInContext);
  const showToast = useToast();
  const navigate = useNavigate();

  const handleSave = async () => {

    try {
      const org = await MU.getUserDetails(userMail);
      await org.remove();
      showToast("Account Deleted Successfully", "success");
      sessionStorage.removeItem("mail");
      localStorage.removeItem("izauthtoken");
      sessionStorage.removeItem("ysentinal-history"); // Clear log history
      navigate("/signin");
      window.location.reload();
    } catch (orgError) {
      console.error("Error ", orgError);
      showToast("Error deleting account", "error");
    }

    try {
      const user = await MU.getUserDetails(userMail);
      await user.remove();
      showToast("Account Deleted Successfully", "success");
      sessionStorage.removeItem("mail");
      localStorage.removeItem("izauthtoken");
      sessionStorage.removeItem("ysentinal-history"); // Clear log history
      navigate("/signin");
      window.location.reload();

    } catch (userError) {
      console.error("Error ", userError);
      showToast("Error deleting account", "error");
    }

  };

  return (
    <div
      className={`DeleteAccount ${isMobile ? "mobile-row" : ""}`}
      onClick={isMobile ? deleteHadler : undefined}
      style={isMobile ? { cursor: "pointer" } : {}}
    >
      <div className="Delete">
        <h1>Delete Account</h1>
        {!hideDescription && (
          <p>
            All data, including your profile and reviews, will be permanently
            deleted instantly and cannot be recovered.
          </p>
        )}
      </div>

      {!isMobile && (
        <span onClick={deleteHadler} style={{ cursor: "pointer", color: "#FF0000" }} className="admin-action">
          Delete Account
        </span>
      )}
      {showDeleteModal && (
        <DeleteAccountSecurity
          handleCancelModel={() => setShowDeleteModal(false)}
          handleSave={handleSave}
        />
      )}
    </div>
  );
}

export default DeleteAccount;
